<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.49 1.5" class="icon">
        <title>minus</title>
        <line x1="17.74" y1="0.75" x2="0.75" y2="0.75"
              style="fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px" v-bind:style="{stroke: color}"/>
    </svg>
</template>

<script>
    export default {
        name: "IconMinus",

        props: {
            color: {
                type: String,
                default: '#231f20'
            }
        }
    }
</script>
